/* eslint-disable import/prefer-default-export -- using named export for consistency with monorepo API design */
import {} from "@next-platform/packages-ts-types/application/types/capabilities";
import React, {} from "react";
import { useApplicationCapabilitiesAllowed } from "./hooks/useApplicationCapabilitiesAllowed";
import { useApplicationCapabilityReady } from "./hooks/useApplicationCapabilityReady";
export function CapabilityGate({ capability, fallbackNode = null, loadingNode = null, children }) {
    const isReady = useApplicationCapabilityReady();
    const isAllowed = useApplicationCapabilitiesAllowed(capability);
    if (!isReady) {
        return React.createElement(React.Fragment, null, loadingNode);
    }
    if (!isAllowed) {
        return React.createElement(React.Fragment, null, fallbackNode);
    }
    return React.createElement(React.Fragment, null, children);
}
